module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    style: (("width:" + (_vm.content.width) + "px;")),
    attrs: {
      "src": _vm.content.url,
      "alt": _vm.content.alt
    }
  }), _vm._v(" "), (_vm.content.caption && _vm.content.caption.length) ? _c('figcaption', [_vm._v(_vm._s(_vm.content.caption))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3edb5e96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Image.vue
// module id = 631
// module chunks = 1